import React, { useState, useEffect } from 'react';

const BannerSection = () => {
  const [currentBanner, setCurrentBanner] = useState(1);
  const [isVisible, setIsVisible] = useState(true);

  const banners = [
    '/banner1.png',
    '/banner2.png',
    '/banner3.png',
    '/banner4.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false); 
      setTimeout(() => {
        setCurrentBanner((prev) => (prev % banners.length) + 1); 
        setIsVisible(true);
      }, 500); 
    }, 5000); 

    return () => clearInterval(interval); 
  }, [banners.length]);

  return (
    <div className="relative w-full overflow-hidden bg-gray-100">
      <img
        src={banners[currentBanner - 1]} 
        alt={`Aabharan Foundation Banner ${currentBanner}`}
        className={`w-full h-auto transition-opacity duration-500 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        loading="eager"
      />
    </div>
  );
};

export default BannerSection;